export enum AssetType {
  IMAGE = 0,
  VIDEO = 1,
  AUDIO = 2,
  COVER_PHOTO = 3,
  TEXT = 4,
  TRIBUTE_VIDEO = 5,
  STOCK_CLIPS = 7,
  TEXT_OVERLAY = 9
}

export enum AssetSource {
  UPLOAD = 'Upload',
  MUSIC_PROVIDER = 'MusicProvider',
  BACKGROUND_SERVICE = 'BackgroundService',
  CLONE = 'Clone'
}

export enum AssetScope {
  PRIVATE = 0,
  PUBLIC = 1,
  ORGANIZATION = 2
}

export enum AssetStatus {
  CONTENT_PREPARING = 'ContentPreparing',
  CONTENT_PREPARED = 'ContentPrepared',
  PREVIEW_CREATED = 'PreviewCreated',
  PREVIEW_RENDERING = 'PreviewRendering',
  VIDEO_RENDERING = 'VideoRendering',
  COMPLETED = 'Completed',
  FAILED = 'Failed'
}

export enum AssetUploadType {
  UPLOADED_CONTENT = 0,
  PUBLIC_ASSET = 1,
  UPLOAD_NEW = 2,
  ORGANIZATION_ASSET = 3
}
